import { PageSidebar } from '@fortem-monorepo/react-spa'
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@fortem-monorepo/react-ui'

import { useMarketSummaryContext } from '@/pages/instruments/market-summary/market-summary-context'

export interface MarketSummarySidebarProps {}

export const MarketSummarySidebar: React.FC<MarketSummarySidebarProps> = ({}) => {
  const { reportSections } = useMarketSummaryContext()

  return (
    <PageSidebar sticky className={'top-12.25'}>
      <SidebarContent>
        <SidebarMenu>
          <SidebarGroup>
            <SidebarGroupContent>
              <SidebarMenu>
                <SidebarMenuItem>
                  <SidebarMenuButton
                    className={'text-sm justify-start font-medium text-fortem-orange opacity-100!'}
                    disabled
                  >
                    Quick Links
                  </SidebarMenuButton>
                </SidebarMenuItem>
                {reportSections.map((section) => {
                  return (
                    <SidebarMenuItem key={section}>
                      <SidebarMenuButton
                        className={'justify-between'}
                        onClick={() => {
                          const el = document.getElementById(section)
                          if (el) {
                            window.scrollTo({
                              top: el.offsetTop,
                              behavior: 'smooth',
                            })
                          }
                        }}
                      >
                        {section}
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  )
                })}
              </SidebarMenu>
            </SidebarGroupContent>
          </SidebarGroup>
        </SidebarMenu>
      </SidebarContent>
    </PageSidebar>
  )
}
